import { styled } from '@mui/material';

import { useParams } from 'react-router';

import { useWorkspaceSwitcherData } from '@app-velocity/modules/teams';

import { WorkspaceSelector } from '../WorkspaceSelector';
import { ProfileButton } from './components/ProfileButton';
import { TeamInfo } from './components/TeamInfo';

const StyledHeader = styled('header')(({ theme }) => ({
  padding: theme.spacing(3),
  borderBottom: '1px solid var(--stroke-stroke-primary-color)',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

const HeaderRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  justifyContent: 'space-between',
}));

export const TopBar = () => {
  const { workspaceId, teamId } = useParams<{
    teamId?: string;
    workspaceId?: string;
  }>();

  const { activeTeam } = useWorkspaceSwitcherData();

  if (!workspaceId || !teamId) return null;

  return (
    <StyledHeader>
      <HeaderRow>
        <WorkspaceSelector />
        <TeamInfo activeTeam={activeTeam} />
        <ProfileButton />
      </HeaderRow>
    </StyledHeader>
  );
};
